import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Table, Chip, Person, fmt, when } from "./kit";

// Otomatik selam: genel anahtar, hesap bazli ac/kapa ve engelli hesaplar.
const AutoGreet = () => {
  const [d, setD] = useState(null);
  const [q, setQ] = useState("");
  const [ara, setAra] = useState("");
  const [yeni, setYeni] = useState("");
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    setLoading(true);
    const r = await api.autoGreet({ q: ara });
    if (r?.status) setD(r);
    setLoading(false);
  }, [ara]);
  useEffect(() => { load(); }, [load]);

  const yap = async (body) => {
    const r = await api.autoGreetSet(body);
    if (!r?.status) window.alert(r?.message || "Kaydedilemedi");
    load();
  };
  const engelle = () => {
    if (!yeni.trim()) return;
    yap({ uniqueID: yeni.trim(), blocked: true });
    setYeni("");
  };

  const rows = (d?.rows || []).map((u) => (
    <tr key={u._id}>
      <td><Person p={u} /></td>
      <td>{u.uniqueID}</td>
      <td>{u.gender || "-"}</td>
      <td>{u.autoGreetOn ? <Chip kind="ok">Açık</Chip> : <Chip kind="wait">Kapalı</Chip>}</td>
      <td>{u.blocked ? <Chip kind="bad">Engelli</Chip> : "-"}</td>
      <td>{fmt(u.sent24)}</td>
      <td>{when(u.lastSeenAt)}</td>
      <td>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          <button className="btn btn-sm btn-outline-primary" onClick={() => yap({ userId: u._id, on: !u.autoGreetOn })}>
            {u.autoGreetOn ? "Kapat" : "Aç"}
          </button>
          <button className="btn btn-sm btn-outline-danger" onClick={() => yap({ uniqueID: u.uniqueID, blocked: !u.blocked })}>
            {u.blocked ? "Engeli kaldır" : "Engelle"}
          </button>
        </div>
      </td>
    </tr>
  ));

  return (
    <div>
      <PageHead
        title="Otomatik Selam"
        sub="Yeni üyelere sunucudan giden otomatik selamlar"
        right={
          <button className={`btn ${d?.enabled ? "btn-danger" : "btn-success"}`} onClick={() => yap({ enabled: !d?.enabled })}>
            {d?.enabled ? "Tümünü kapat" : "Tümünü aç"}
          </button>
        }
      />
      <Tiles
        items={[
          { label: "Genel durum", value: d?.enabled ? "Açık" : "Kapalı" },
          { label: "Son 24 saat selam", value: fmt(d?.total24) },
          { label: "Engelli hesap", value: fmt(d?.blocked?.length) },
        ]}
      />
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", margin: "12px 0" }}>
        <input className="form-control" style={{ maxWidth: 240 }} placeholder="ID veya isim ara" value={q} onChange={(e) => setQ(e.target.value)} onKeyDown={(e) => e.key === "Enter" && setAra(q.trim())} />
        <button className="btn btn-primary" onClick={() => setAra(q.trim())}>Ara</button>
        <input className="form-control" style={{ maxWidth: 180 }} placeholder="Engellenecek ID" value={yeni} onChange={(e) => setYeni(e.target.value)} />
        <button className="btn btn-outline-danger" onClick={engelle}>Engelle</button>
      </div>
      <Table head={["Kullanıcı", "ID", "Cinsiyet", "Selam", "Engel", "24 saat", "Son görülme", ""]} rows={rows} loading={loading} />
    </div>
  );
};

export default AutoGreet;
